module.exports = __webpack_public_path__ + "static/media/vk-global-pub-logo@3x.d5d03321.png";